import { Button, Grid, TextField } from '@mui/material'
import { useCallback, useState } from 'react'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'

const RelatorioProdutosAVencer = () => {
  const [nrDia, setNrDia] = useState(30)
  const [loading, setLoading] = useState(false)

  const emiteRelatorio = useCallback(() => {
    if (!nrDia || nrDia <= 0) return

    setLoading(true)

    metodoPrograma('geraRelatorio', {
      nrDias: nrDia,
    })
      .then((res) => {
        if (res.status) {
          const base64 = res.arquivo

          const byteCharacters = atob(base64)
          const byteNumbers = new Array(byteCharacters.length)

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNumbers)

          const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')

          link.href = url
          link.download = 'relatorio_produtos_a_vencer.xlsx'
          document.body.appendChild(link)
          link.click()

          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      .finally(() => setLoading(false))
  }, [nrDia])

  return (
    <Programa codigo="CtrlRelatorioProdutosAVencer">
      <Grid container spacing={2} style={{ marginTop: 50 }}>
        <Grid item xs={12} md={3}></Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Dias para Vencimento"
            type="number"
            margin="dense"
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={nrDia}
            onChange={(e) => setNrDia(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3}></Grid>

        <Grid item xs={3}></Grid>

        <Grid item xs={6} style={{ marginTop: 50 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={emiteRelatorio}
            disabled={loading || !nrDia || nrDia <= 0}
          >
            {loading ? 'Gerando...' : 'Emitir Relatório'}
          </Button>
        </Grid>
      </Grid>
    </Programa>
  )
}

export default RelatorioProdutosAVencer
